import { render } from "./WildGameEditModal.vue?vue&type=template&id=f8734baa"
import script from "./WildGameEditModal.vue?vue&type=script&lang=js"
export * from "./WildGameEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__